import CaseFolders from "../CaseFolders";
import Notifications from "../Notifications";
import Overview from "../Overview";

import Settings from "../Settings";

import ViewCaseFolder from "../case-folder/ViewCaseFolder";

export const BaliffRoute = [
  {
    title: "Overview",
    path: "/baliff/overview",
    component: Overview,
  },
  {
    title: "Case Folders",
    path: "/baliff/case-folders",
    component: CaseFolders,
  },

  {
    title: "View Case Folder",
    path: "/baliff/case-folders/view",
    component: ViewCaseFolder,
  },

  {
    title: "Notification",
    path: "/baliff/notification",
    component: Notifications,
  },
  {
    title: "Setting",
    path: "/baliff/setting",
    component: Settings,
  },
];
